export const APP_VERSION_HEADER_NAME = 'x-app-version';

export enum SortDir {
  ASC = 'asc',
  DESC = 'desc',
}

export enum eExportFormat {
  PDF = 'PDF',
  CSV = 'CSV',
  PRINT = 'PRINT',
  JSON = 'JSON',
  EXCEL = 'EXCEL',
}

export enum eEnv {
  DEV = 'development',
  PROD = 'production',
  TEST = 'test',
  STAGE = 'staging',
  LOCAL = 'localhost',
}

export enum eLanguage {
  enGB = 'en-GB',
  deDE = 'de-DE',
}

export enum NotificationFilter {
  ALL = 'all',
  UNREAD = 'unread',
}

export const defaultLanguage = 'en-GB';

export enum LogoType {
  DARK_MODE = ('DARK_MODE'),
  NORMAL = ('NORMAL'),
}

export const MaxTenantLogoSizeBytes = 2 * 1024 * 1024; // 2 MB, keep in sync with StorageUploads.MaxFileSizeBytes on BE
export const MaxTenantLogoSizeMb = 2;

export const SupportedTenantLogoImageFormats = [
  // keep in sync with StorageUploads.AllowedMimeTypes on BE
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
];

export enum EventType {
  CSS_LOADED = 'app-css-loaded',
  MOUSE_DOWN = 'mousedown',
}
